'use strict';

angular.module('TurneroApp').service('rolesService', ['$resource', 'portal', function ($resource, portal) {
    return $resource(portal.getUrlServer() + 'api/Rol/:id', { id: '@Id_Rol' }, {
        Get_Listado: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Rol/Get_Listado/',
        },
        getInfo: {
            method: 'GET', 
            url: portal.getUrlServer() + 'api/Rol/getInfo/',
        },
        getTieneRol: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Rol/getTieneRol/',
        },
        save: {
            method: 'POST'
        },
        'delete': {
            param:{
                id : 'id'
            },
            method: 'DELETE',
        },
        update: {
            method: 'PUT',
        }
    });
}]);



// WEBPACK FOOTER //
// ./app/components/roles/rolesService.js